export const t = {
  // 首页 nav
  'index': 'Home',
  'index_contactme': 'Contact us',
  'index_aboutus': 'About us',
  'index_platform': 'Bolo Platform',
  // 首页 悬浮条
  'index_adv': 'Advantage',
  'index_service': 'Services',
  'index_cover': 'Coverage',
  'index_partner': 'Partner',
  'index_bolo': 'Bolo Pass',
  // 首页banner 图
  'index_banner_title': 'Provide WeChat Acquiring and Marketing Integration Services',
  'index_appy_but': 'Apply Now',
  // 首页 服务优势
  'index_adv_title': 'Our Superiority',
  'index_adv_text1_title': 'Convenient & secure cross-border acquiring',
  'index_adv_text1': 'After the bank liquidates, the merchant receives the Hong Kong dollar, has the money service operator license, and the fund circulation is safe and reliable',
  'index_adv_text2_title': 'Multi-Channel Online Promotion',
  'index_adv_text2': 'Cooperation with Wechat, Ali, Qyer, Mafengwo, Ctrip and so on',
  'index_adv_text3_title': 'Multi-Dimensional Interaction',
  'index_adv_text3': 'Restaurants and shoppings ⇆ attractionand entertainment',
  'index_adv_text4_title': 'Effective Support',
  'index_adv_text4': 'Staffs 24 hours Stand By to solve problems, and provide system upgrade termly',
  'index_adv_text5_title': 'Professional IT team support',
  'index_adv_text5': 'ensure payment security, the server can withstand millions of user visits, large-scale marketing events can support, rapid integration with partner systems',
  // 首页商品与服务
  'index_service_title': 'products and services',
  'index_service_text1_name': 'WeChat Pay',
  'index_service_text1_namdes': 'Provide convenient payment methods',
  'index_service_text1_desc': 'Convenient, QR code Payment, popular by Chinese travelers.Support a variety of payment methods to meet the diverse needs.',
  'index_service_off_title': 'Offline payment support',
  'index_service_off_desc': ' Quickpay, QR code Payment, POS integration',
  'index_service_on_title': 'Online payment support',
  'index_service_on_desc': 'WeChat Public Account payment, website payment, self-service ticket machine payment',
  // service 2
  'index_service_text2_name': 'Bolo Merchant Platform & App',
  'index_service_text2_namdes': 'Receiving convenient, clear revenue',
  'index_service_text2_desc': 'business reports online, analyze sales trends, revenue status at a glance, super-account can instantly view a number of store sales. Support dual mode payment, payment instant notification, support multiple staff at the same time collection, real-time audit, history, sales statistics.',
  // service 3
  'index_service_text3_name': 'Bolo Pass',
  'index_service_text3_namdes': 'Providing a full range of marketing tools',
  'index_service_text3_desc': 'For cooperative merchants to provide online editing and platform display, the use of Bolo PASS publicity, combined with WeChat Office Account to realize the brand promotion of the merchant.',
  // service 4
  'index_service_text4_name': 'WeChat Office Account',
  'index_service_text4_namdes': 'Provide a new type of branding services',
  'index_service_text4_desc': 'Apply the WeChat Office Account for connecting Chinese travelers, allowing brands to deliver rich content to users through WeChat Office Account, thereby expanding the customer market.',
  // service 5
  'index_service_text5_name': 'Online Mall',
  'index_service_text5_namdes': 'Provide a more convenient sales platform',
  'index_service_text5_desc': 'Combined with WeChat Office Account, for each merchant to build an online store, customers can shopping online self-help, eliminating the cumbersome collection process.',
  // 业务范围
  'index_scope_title': 'Global Coverage',
  'index_scope_desc': 'Malaysia and Indonesia will be ready in the 1st quarter of 2018 Japan, Australia and New Zealand, France will be ready in the 2nd quarter of 2019',
  // 部分合作品牌
  'index_brand_title': 'Part of Partnering Merchants',
  // input
  'index_bolo_merchant_title': 'Apply for Bolo Merchant',
  'index_input_name': 'Contact name',
  'index_input_tel': 'Phone number',
  'index_input_email': 'Contact Email',
  'index_input_city': 'City',
  'index_input_company': 'Company name',
  'index_input_company_business': 'Company business',
  'index_input_company_address': 'Company address',
  'index_input_desc': 'Your message',
  'index_no_name': 'Please enter a contact',
  'index_no_tel': 'Please enter a contact number ',
  'index_no_email': 'Please enter a concat email',
  'index_no_city': 'Please enter your city',
  'index_no_company': 'Please enter the company name',
  'index_no_company_business': 'Please enter the main business of your company',
  'index_no_company_address': 'Please enter the full address of your company',
  'index_email_error': 'Please fill in the correct email format.',
  'index_input_tip_err': 'Information is incomplete',
  'index_input_tip_succ': 'Application Success',
  'index_input_tip_timer': 'You submitted too often, please submit it {0} minutes later',
  'index_input_err_but': 'Supplementary information',
  'index_input_succ_but': 'get it',
  'index_submit': 'Submit',
  'index_input_desc_tips': '*Please understand the following rules before applying：\n' + '\n' + 'The pineapple merchants only accept applications from local merchants in Hong Kong, Thailand and Malaysia, and do not accept applications from mainland China and individual users. Services in other regions are expanding. Please fill in the company information and submit it for review in the left border. After the information is approved, local colleagues will come to you to provide services.\n' + '\n*If in doubt, please enter your message and submit.',

  // 国家
  'france': 'France',
  'china': 'China',
  'japan': 'Japan',
  'hk': 'HongKong',
  'tailland': 'Thailand',
  'vietnam': 'Vietnam',
  'cambodia': 'Cambodia',
  'mala': 'Malaysia',
  'newzea': 'New Zealand',
  'austra': 'Australia',
  // 页尾
  'footer_tel_label': 'tel',
  'footer_email_label': 'email',
  'footer_adress_label': 'adress',
  'footer_adress': 'Flat 09, 13/F, Block 2, Ever Gain Plaza, No. 88 Container Port Road, Kwai Chung, N.T Hong Kong',
  'footer_bolo': 'Bolo Merchant',
  'footer_wantu': 'www.wantu.cn',
  'footer_bolo_pass': 'Bolo Pass',
  // 联系我们
  'connectme_hk_link': 'links',
  'connectme_connect_lab': 'Contact',
  'connectme_connmeth_lab': 'Contact',
  'connectme_sha': 'Shanghai Office',
  'connectme_sha_adress': ' Room B,11 Floor, Yun Du Hongqiao Mansion, 930 Zhongshan West Road, Changning District, Shanghai',
  'connectme_sz': 'Shenzhen Office',
  'connectme_sz_adress': ' Room 5A1 of BLDG 5, Nanyuanfengye Building, Nanshan Rd., Nanshan Disrtict, Shenzhen, Guangdong',
  'connectme_hk': 'Hongkong Office',
  'connectme_hk_name': 'Provider',
  'connectme_hk_adress': ' Workshop C, 22/F, Reason Group Tower, No. 403 Castle Peak Road, Kwai Chung, N.T. , Hong Kong',
  'connectme_hk_service': 'Jason Pay Limited ',
  'connectme_tail': 'Thailand Office',
  'connectme_taill_adress': ' The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand.50100',
  'connectme_vietnam': 'Vietnam Office',
  'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
  'connectme_kuala': 'Kuala Lumpur Office',
  'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
  'connectme_sabah': 'Sabah Office',
  'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',
  // 关于我们
  'aboutus_wantu_title': 'FastPay Introduction',
  'aboutus_wantu_p1': 'Fast Pay Limited was established in April 2017, based in Hong Kong, branch offices are location in Shenzhen, Shanghai, and Beijing for more than 3,000 merchants, has announced a strategic partnership with WeChat pay and Alipay. The service is global coverage, business currently including Hong Kong, Thailand, Vietnam, Sabah, and Australia. Fast Pay (One Two Go Co Limited is a parent Company)  supporting WeChat pay & Alipay offline / online payment gateways and assessment for merchants. It has become a new force in the payment field in recent years. As the Chinese retail industry has been changing, characterized by the widespread use of technologies. So we provide diversified services, such as cross-border e-commerce field, to help merchants entering the new retail era.',
  'aboutus_partner': 'Partner',
  'aboutus_partner_wechat': 'WeChat Pay',
  'aboutus_partner_alipay': 'Alipay',
  'aboutus_partner_abc': 'ABC',
  'aboutus_partner_ccb': 'CCB',
  'aboutus_partner_cmb': 'CMB',
  'aboutus_partner_unpay': 'Union Pay',
  'aboutus_partner_visa': 'VISA',
  'aboutus_partner_master': 'Master card',
  'aboutus_partner_mafengwo': 'mafengwo',
  'aboutus_partner_qyer': 'qyer',
  'aboutus_partner_tempus': 'tempus',
  'aboutus_partner_jason': 'Jason Pay',
  'aboutus_activity_lab': 'Activity',
  'aboutus_activity_title1': 'Alipay oversea activity of 12.12 in 2015',
  'aboutus_activity_desc1': 'To expand overseas market, third-party Payment cooperated with Hitour’s retailers in Singapore, Phuket, Chiang Mai and Pattaya.',
  'aboutus_activity_title2': 'Thailand restaurant sales promotion in 2016',
  'aboutus_activity_desc2': 'Hitour and the Thailand restaurant jointly held an unprecedented grand event - 50 percent off eating big meals',
  'aboutus_activity_title3': '2017 New Year three red envelopes',
  'aboutus_activity_desc3': 'Hitour joint Thailand Tourism Board, WeChat Pay, Ali raccoon, held in Jungceylon Shopping Destination ',
  'aboutus_award_title': 'Awards',
  'aboutus_year': '',
  'aboutus_award_p1': 'Hitour as the sole partner of Alipay activity of 12.12 in Thailand',
  'aboutus_award_p2': 'ios App recommended by App Store for 4 times',
  'aboutus_award_p3': 'Android App recommended by Wandoujia',
  'aboutus_award_p4': 'China Travel Internet Billboard Best overseas destination product booking platform',
  'aboutus_award_p5': 'Industry Innovation Award of Wechat Pay Cooperative Partner',
  'aboutus_award_p6': 'Thai Songkran WeChat Pay Overseas Media Entertainment Exclusive',
  'aboutus_award_p7': 'Bolo Pass Mini Programs was chosen as Outstanding Applet Development Representative',
  //
  'fast_pay': {
    // 首页 悬浮条
    'index_adv': 'Advantage',
    'index_service': 'Services',
    'index_cover': 'Coverage',
    'index_partner': 'Partner',
    'index_bolo': 'Apply',
    // 首页banner 图
    'index_banner_title': 'EXPAND YOUR BUSINESS<br>Connect Your Business to Chinese Consumer',
    'index_appy_but': 'Apply Now',
    // 首页 服务优势
    'index_adv_title': 'Advantage',
    'index_adv_text1_title': 'HUGE CUSTOMER FLOW',
    'index_adv_text1': 'Your store\'s info is visible to 150 million mobile Alipay customers from China',
    'index_adv_text2_title': 'INTELLIGENT MARKETING',
    'index_adv_text2': 'Precisely target customers with discount information',
    'index_adv_text3_title': 'CONVENIENT PAYMENT',
    'index_adv_text3': 'Payment products suitable for various business scenarios',
    'index_adv_text4_title': 'BUSINESS ANALYSIS',
    'index_adv_text4': 'Understand Chinese customers and provide business recommendations',
    // 'index_adv_text5_title': '專業技術研發團隊⽀援',
    // 'index_adv_text5': '專業技術團隊，保障⽀付安全，服務器可以承受數百萬⽤⼾訪問，⼤型營銷事件可以⽀持，與合作夥伴的系統快速融合',
    // 首页商品与服务
    'index_service_title': 'Services',
    'index_service_text1_name': 'In-store Payment',
    'index_service_text1_namdes': 'Including Barcode Payment and Merchant QR Code Payment',
    'index_service_text1_desc': 'It is suitable for duty-free shops, restaurants, convenience stores, shopping malls, chain stores, and other service industries.At the same time Fast Pay support for RMB and HongKong dollar trading in Alipay. The merchant only needs a Smart POS / Mobile Phone to acquiring.',
    'index_service_off_title': '線下微信⽀付',
    'index_service_off_desc': ' 刷卡⽀付、掃碼⽀付、POS機融合',
    'index_service_on_title': '線上微信⽀付',
    'index_service_on_desc': 'PC網站⽀付、⾃助售票機⽀付、⼿機⽀付、公眾號⽀付',
    // service 2
    'index_service_text2_name': 'For Alipay Online Payment',
    'index_service_text2_namdes': 'Including Web / Wap / APP Payment',
    'index_service_text2_desc': 'It is suitable for PC website, mobile phone WAP and APP, and offline vending machine, POS system fusion to Alipay acquiring. It requires merchants to have the ability of technological development, and complete the connection with the API files provided by Fast Pay.',
    // service 3
    'index_service_text3_name': 'Bolo Merchant Platform & App',
    'index_service_text3_namdes': 'Receiving convenient, clear revenue',
    'index_service_text3_desc': 'Business reports online, analyze sales trends, revenue status at a glance, super-account can instantly view a number of store sales. Support dual mode payment, payment instant notification, support multiple staff at the same time collection, real-time audit, history, sales statistics.',
    'index_service_text3_name_2': 'Online Mall',
    'index_service_text3_namdes_2': 'Provide a more convenient sales platform',
    'index_service_text3_desc_2': 'Combined with WeChat Office Account, for each merchant to build an online store, customers can shopping online self-help, eliminating the cumbersome collection process.',
    // 业务范围
    'index_scope_title': '全球業務',
    'index_scope_desc': '⾺來⻄亞和印尼將在2018第壹季度開放。⽇本、韩国、澳⼤利亚和新⻄兰、法国將在2019戰略部署。',
    // 部分合作品牌
    'index_brand_title': '部分合作品牌',
    // input
    'index_bolo_merchant_title': '⽴即申請支付寶收款',
    'index_input_company': '填寫公司名',
    'index_input_name': '請輸入連絡人',
    'index_input_tel': '請輸入連絡電話',
    'index_input_email': '請輸入連絡郵箱地址',
    'index_input_city': '請輸入所在都市',
    'index_input_desc': '您的留言',
    'index_no_name': '請輸入聯繫人',
    'index_no_tel': '請輸入電話號',
    'index_no_email': '請輸入郵箱',
    'index_no_city': '請輸入城市',
    'index_email_error': '請填入正確的郵箱格式',
    'index_input_tip_err': '資訊不完整',
    'index_input_tip_succ': '申請成功',
    'index_input_err_but': '繼續完善資訊',
    'index_input_succ_but': '知道了',

    'index_submit': '提交',
    // 国家
    'france': '法國',
    'china': '中國',
    'japan': '日本',
    'hk': '香港',
    'tailland': '泰國',
    'vietnam': '越南',
    'cambodia': '高棉',
    'mala': '馬來西亞',
    'newzea': '紐西蘭',
    'austra': '澳大利亞',
    // 页尾
    'footer_tel_label': '電話',
    'footer_email_label': '郵箱',
    'footer_adress_label': '地址',
    'footer_adress': 'Flat 09, 13/F, Block 2, Ever Gain Plaza, No. 88 Container Port Road, Kwai Chung, N.T Hong Kong',
    'footer_bolo': '菠蘿商⼾下載',
    'footer_wantu': '玩途⾃由⾏',
    'footer_bolo_pass': '菠蘿PASS服務號',
    // 联系我们
    'connectme_hk_link': '網站',
    'connectme_connect_lab': '聯繫⼈',
    'connectme_connmeth_lab': '聯絡⽅式',
    'connectme_sha': '上海辦事處',
    'connectme_sha_adress': '上海市⻑䌀區中⼭⻄路930號雲都虹橋⼤廈11樓B座',
    'connectme_sz': '深圳辦事處',
    'connectme_sz_adress': '廣東省南山區南山大道南園楓葉大廈5A1',
    'connectme_hk': '⾹港辦事處',
    'connectme_hk_name': '特約服務商',
    'connectme_hk_adress': '⾹港九⻰⻓沙湾⻓裕街8号亿京⼴场1期1802室',
    'connectme_hk_service': '戬⾠有限公司Jason Pay Limited',
    'connectme_tail': '泰國辦事處',
    'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
    'connectme_vietnam': '越南辦事處',
    'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
    // 关于我们
    'aboutus_wantu_title': 'FastPay介紹',
    'aboutus_wantu_p1': '玩途旅⾏（wantu.cn）成⽴於2013年，專註於服務中國⾃由⾏⽤⼾出境遊，提供從機票酒店預訂，⾏程中的項⽬體驗預訂，到境外商⼾移動⽀付網絡覆蓋，以及⾏程結束後的再消費。從⾃由⾏⽤⼾出境遊的⾏前、⾏中、⾏後的全⽅位服務。',
    'aboutus_wantu_p2': '2016年初，玩途旅⾏與微信⽀付簽署了境外服務商合作協議，為微信⽀付開拓海外市場，將中國的移動⽀付，無現⾦體驗推廣到世界各地，服務於廣⼤中國出境遊遊客。One TwoGo Co., Limited隸屬於玩途旅⾏，是基於⽀付服務的玩途在海外旅遊服務的⼦品牌，深⼊⽬的地當地的旅⾏指南，⼀站式搞定吃喝玩樂。在泰國、越南、⾹港、⾺來⻄亞均有當地辦事處 。',
    'aboutus_wantu_p3': '玩途旅⾏主要投資⼈是騰邦集團，2016年 騰邦集團對我們進⾏B輪融資，2017年 騰邦集團籌備與我們進⾏C輪融資。騰邦集團於深交所(300178)及港交所(6880)上市是中國500⼤企業2016年騰邦集團是全中國營收排名第80位的國企，達797億⼈⺠幣，䋿⼒強⼤。騰邦集團的旅遊佈局，亦是我們強⽽有⼒的後盾。',
    'aboutus_wantu_p4': '2017年8⽉,我們已服務超過800萬位中國遊客，其中菠蘿PASS已經擁有60萬位會員。騰邦集團每⽉為超過15萬位來港中國遊客提供針對式服務。',
    'aboutus_partner': '合作夥伴',
    'aboutus_partner_wechat': '微信⽀付',
    'aboutus_partner_alipay': '⽀付寶',
    'aboutus_partner_abc': '中國農業銀⾏',
    'aboutus_partner_ccb': '中國建設銀⾏',
    'aboutus_partner_cmb': '招商銀⾏',
    'aboutus_partner_unpay': '中國銀聯',
    'aboutus_partner_visa': 'VISA',
    'aboutus_partner_master': 'Master card',
    'aboutus_partner_mafengwo': '螞蜂窩',
    'aboutus_partner_qyer': '窮遊',
    'aboutus_partner_tempus': '騰邦',
    'aboutus_partner_jason': 'Jason Pay',
    'aboutus_activity_lab': '過往活動',
    'aboutus_activity_title1': '2015年⽀付寶海外雙⼗⼆狂歡節',
    'aboutus_activity_desc1': '為拓展玩途在新加坡、普吉島、清邁、芭提雅合作的海外第三⽅⽀付市場',
    'aboutus_activity_title2': '2016年泰國餐廳5折吃⼤餐',
    'aboutus_activity_desc2': '玩途與泰國餐廳聯合舉辦空前盛⼤活動——5折吃⼤餐',
    'aboutus_activity_title3': '2017新春三重紅包好禮',
    'aboutus_activity_desc3': '玩途聯⼿泰國旅遊局、微信⽀付、阿貍形象，在江⻄冷舉辦⼤型活動',
    'aboutus_award_title': '我們的獎項',
    'aboutus_year': '年',
    'aboutus_award_p1': '⽀付寶雙⼗⼆海外狂歡節，泰國唯⼀合作夥伴',
    'aboutus_award_p2': '⼿機IOS版被蘋果App store四次評為“新優產品推薦”',
    'aboutus_award_p3': '⼿機的Android版獲得“豌⾖莢設計獎”',
    'aboutus_award_p4': '中國旅業互聯網⾵雲榜最佳海外⽬的地產品預訂平台',
    'aboutus_award_p5': '獲得“微信⽀付合作夥伴2016年度⾏業創新獎”',
    'aboutus_award_p6': '泰國潑⽔節微信⽀付境外媒體招待玩途獨家',
    'aboutus_award_p7': '菠蘿通⼩程序被選為“優秀⼩程序開發代表'
  }
}



// WEBPACK FOOTER //
// ./src/_components/i18n/en.js